import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authService } from '@/services/auth/auth.service';
import { resolveLandingRoute } from '@/utils/roleRouting';

export default function GoogleCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          toast.error(`Google login failed: ${error}`);
          navigate('/login');
          return;
        }

        if (!code) {
          toast.error('No authorization code received');
          navigate('/login');
          return;
        }

        // Send code to backend
        const response = await authService.googleLogin(code);
        localStorage.setItem('adminToken', response.token);
        localStorage.setItem('adminUser', JSON.stringify(response.user));
        window.dispatchEvent(new Event('authChange'));
        toast.success('Login successful!');
        navigate(resolveLandingRoute(response.user));
      } catch (error: any) {
        toast.error(error.response?.data?.message || 'Google login failed');
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p>Authenticating...</p>
    </div>
  );
}
